// menuGroups — F9.5 WAVE 2E · Admin Mega-Dropdown source data.
// 7 groups × 24 items. Each item has: key, labelKey (i18n), icon, to, module?
// `module` acts as a plan-gate hint: non-admin users without the matching
// module entitlement see the item greyed-out with a lock badge.
import {
    LayoutDashboard,
    Target,
    Bookmark,
    Send,
    Mail,
    Layers,
    Radio,
    Globe,
    Trophy,
    Award,
    Boxes,
    History,
    ShoppingBag,
    Store,
    Package,
    Palette,
    Wallet,
    FileText,
    User as UserIcon,
    Coins,
    CreditCard,
    DollarSign,
    Database,
    HandCoins,
    Handshake,
    ShieldCheck,
    TrendingUp,
    Users,
    ToggleRight,
    ScrollText,
    Webhook,
    Lock,
    Tag,
    Flag,
    Megaphone,
    Users as UsersIcon,
    Building2,
    Target as TargetIcon,
    GitBranch as GitBranchIcon,
    Route as RouteIcon,
    UserCog as UserCogIcon,
    Brain,
    Workflow as WorkflowIcon,
    FileCheck2,
    CheckCircle2,
    ClipboardList,
    Cpu,
    Rss,
    Radio as RadioIcon,
    Send as SendIcon,
} from "lucide-react";

import { applyMenuDiscoveryExtensions } from "@/data/menuGroups_discovery_extensions";

const _MENU_GROUPS_RAW = [
    {
        key: "workspace",
        headerKey: "admin_menu.group.workspace",
        items: [
            { key: "dashboard", labelKey: "admin_menu.item.dashboard", icon: LayoutDashboard, to: "/dashboard" },
            { key: "dashboard-legacy", labelKey: "admin_menu.item.dashboard_legacy", icon: History, to: "/dashboard/legacy" },
            { key: "launcher", labelKey: "admin_menu.item.launcher", icon: Boxes, to: "/app/launcher", hero: true },
            { key: "lead-engine", labelKey: "admin_menu.item.lead_engine", icon: Target, to: "/leads", module: "lead_engine" },
            { key: "saved-leads", labelKey: "admin_menu.item.saved_leads", icon: Bookmark, to: "/leads/saved", module: "lead_engine" },
            { key: "outreach", labelKey: "admin_menu.item.outreach", icon: Send, to: "/outreach", module: "outreach" },
            { key: "templates", labelKey: "admin_menu.item.templates", icon: Mail, to: "/outreach/templates", module: "outreach" },
            { key: "sequences", labelKey: "admin_menu.item.sequences", icon: Layers, to: "/outreach/sequences", module: "outreach" },
            { key: "campaigns", labelKey: "admin_menu.item.campaigns", icon: Radio, to: "/outreach/campaigns", module: "outreach" },
        ],
    },
    {
        key: "ai_suite",
        headerKey: "admin_menu.group.ai_suite",
        items: [
            { key: "universe", labelKey: "admin_menu.item.universe", icon: Globe, to: "/universe", module: "universe" },
            { key: "civilization", labelKey: "admin_menu.item.civilization", icon: Trophy, to: "/civilization", module: "civilization" },
            { key: "badges", labelKey: "admin_menu.item.badges", icon: Award, to: "/civilization/badges", module: "civilization" },
        ],
    },
    {
        // Motore 11/14 · CRM Engine · Phase A+B+C+D+E · 13 voci.
        key: "crm",
        label: "CRM",
        adminOnly: true,
        items: [
            { key: "admin-crm-contacts", label: "Contacts", icon: UsersIcon, to: "/admin/crm/contacts", adminOnly: true },
            { key: "admin-crm-accounts", label: "Accounts", icon: Building2, to: "/admin/crm/accounts", adminOnly: true },
            { key: "admin-crm-deals", label: "Deals", icon: TargetIcon, to: "/admin/crm/deals", adminOnly: true },
            { key: "admin-crm-pipeline", label: "Pipeline", icon: GitBranchIcon, to: "/admin/crm/pipeline", adminOnly: true },
            { key: "admin-crm-routing", label: "Routing", icon: RouteIcon, to: "/admin/crm/routing", adminOnly: true },
            { key: "admin-crm-agents", label: "Agents", icon: UserCogIcon, to: "/admin/crm/agents", adminOnly: true },
            { key: "admin-crm-funnel", label: "Funnel", icon: GitBranchIcon, to: "/admin/crm/funnel", adminOnly: true },
            { key: "admin-crm-ai-decisions", label: "AI Decisions", icon: Brain, to: "/admin/crm/ai-decisions", adminOnly: true },
            { key: "admin-crm-workflows", label: "Workflows", icon: WorkflowIcon, to: "/admin/crm/workflows", adminOnly: true },
            { key: "admin-crm-policies", label: "Policies", icon: FileCheck2, to: "/admin/crm/policies", adminOnly: true },
            { key: "admin-crm-approvals", label: "Approvals", icon: CheckCircle2, to: "/admin/crm/approvals", adminOnly: true },
            { key: "admin-crm-audit", label: "Audit", icon: ClipboardList, to: "/admin/crm/audit", adminOnly: true },
            { key: "admin-crm-supervisor", label: "Supervisor", icon: Cpu, to: "/admin/crm/supervisor", adminOnly: true },
        ],
    },
    {
        // Motore 12/14 · Press Engine · Phase A+B+C · 3 voci.
        key: "press",
        label: "PRESS",
        adminOnly: true,
        items: [
            { key: "admin-press-releases", label: "Releases", icon: FileCheck2, to: "/admin/press/releases", adminOnly: true },
            { key: "admin-press-generator", label: "Generator", icon: FileCheck2, to: "/admin/press/generator", adminOnly: true },
            { key: "admin-press-distribution", label: "Distribution", icon: FileCheck2, to: "/admin/press/distribution", adminOnly: true },
        ],
    },
    {
        // Motore 13/14 · Distribution Engine · Phase A+B+C · 6 voci · additive · zero-touch M12.
        // Wave D.4 extension: +6 voci Director Governance (additive · zero-touch Phase A/B/C).
        key: "distribution",
        label: "DISTRIBUZIONE",
        adminOnly: true,
        items: [
            { key: "admin-distribution-jobs", label: "Lavori di distribuzione", icon: WorkflowIcon, to: "/admin/distribution/jobs", adminOnly: true },
            { key: "admin-distribution-channels", label: "Canali di distribuzione", icon: RadioIcon, to: "/admin/distribution/channels", adminOnly: true },
            { key: "admin-distribution-email", label: "Email", icon: SendIcon, to: "/admin/distribution/email", adminOnly: true },
            { key: "admin-distribution-webhook", label: "Webhook", icon: Webhook, to: "/admin/distribution/webhook", adminOnly: true },
            { key: "admin-distribution-rss", label: "RSS", icon: Rss, to: "/admin/distribution/rss", adminOnly: true },
            { key: "admin-distribution-atom", label: "Atom", icon: Rss, to: "/admin/distribution/atom", adminOnly: true },
            { key: "admin-distribution-authority", label: "Autorevolezza", icon: ShieldCheck, to: "/admin/distribution/authority", adminOnly: true },
            { key: "admin-distribution-policies", label: "Policy", icon: ScrollText, to: "/admin/distribution/policies", adminOnly: true },
            { key: "admin-distribution-supervisor", label: "Supervisore", icon: Cpu, to: "/admin/distribution/supervisor", adminOnly: true },
            { key: "admin-distribution-decisions", label: "Decisioni", icon: Brain, to: "/admin/distribution/decisions", adminOnly: true },
            { key: "admin-distribution-approvals", label: "Approvazioni", icon: CheckCircle2, to: "/admin/distribution/approvals", adminOnly: true },
            { key: "admin-distribution-workflows", label: "Workflow", icon: ClipboardList, to: "/admin/distribution/workflows", adminOnly: true },
        ],
    },
    {
        // Wave Marketplace V10 · MP.6 Sidebar Restructure · 3 sezioni dedicate.
        // Sezione 1 · Marketplace user-visible · 7 link (tutti authenticated).
        key: "marketplace_v10",
        label: "Marketplace",
        items: [
            { key: "mp10-catalog", label: "Esplora catalogo", icon: Store, to: "/marketplace/v10" },
            { key: "mp10-hub", label: "Marketplace Hub", icon: ShoppingBag, to: "/marketplace" },
            { key: "mp10-wishlist", label: "Wishlist", icon: Bookmark, to: "/marketplace/wishlist" },
            { key: "mp10-cart", label: "Carrello", icon: Package, to: "/cart" },
            { key: "mp10-library", label: "La mia libreria", icon: Package, to: "/marketplace/library" },
            { key: "mp10-bookings", label: "Service bookings", icon: ClipboardList, to: "/marketplace/service-bookings" },
            { key: "mp10-redemptions", label: "Token redemptions", icon: Coins, to: "/marketplace/token-redemptions" },
        ],
    },
    {
        // Hotfix header-cleanup · gruppo "Community" sostituisce "Creator Studio" + "Partnership".
        // Link piatto top-level · porta a /community (CommunityFeed).
        key: "community",
        headerKey: "admin_menu.group.community",
        items: [
            { key: "community-feed", labelKey: "admin_menu.item.community_feed", icon: Users, to: "/community" },
        ],
    },
    {
        // Sezione 3 · Admin Marketplace · 8 link · adminOnly.
        key: "admin_marketplace",
        label: "Admin Marketplace",
        adminOnly: true,
        items: [
            { key: "adm-mp-overview", label: "Overview", icon: ShieldCheck, to: "/admin/marketplace/v10", adminOnly: true },
            { key: "adm-mp-moderation", label: "Moderation queue", icon: FileCheck2, to: "/admin/marketplace/moderation", adminOnly: true, badge: "admin_moderation_pending" },
            { key: "adm-mp-assets", label: "Gestione asset", icon: Package, to: "/admin/marketplace/assets", adminOnly: true },
            { key: "adm-mp-creators", label: "Gestione creator", icon: Users, to: "/admin/marketplace/creators", adminOnly: true },
            { key: "adm-mp-reviews", label: "Reviews moderation", icon: Flag, to: "/admin/marketplace/reviews", adminOnly: true },
            { key: "adm-mp-payouts", label: "Payouts", icon: Wallet, to: "/admin/marketplace/payouts", adminOnly: true },
            { key: "adm-mp-fee-config", label: "Fee config", icon: Tag, to: "/admin/marketplace/fee-config", adminOnly: true },
            { key: "adm-mp-audit", label: "Audit log", icon: ScrollText, to: "/admin/marketplace/audit", adminOnly: true },
        ],
    },
    {
        // Hotfix sidebar · gruppi "content" e "account" rimossi dal sidebar/header dashboard.
        // Pagine linkate (Blog, Social, Profile, Credits, Billing, Pricing, Privacy) restano
        // accessibili dal UserHub `/app/launcher` nelle categorie Content/Account/Credits & Billing.
        // Hotfix header-cleanup · gruppo "partnership" rimosso dal header dashboard.
        // Pagine partnership restano accessibili da /app/launcher (UserHubPage).
        // Nota: motore 10/14 Leads + Outreach M10 restano in gruppo dedicato più sotto.
        key: "admin",
        headerKey: "admin_menu.group.admin",
        adminOnly: true,
        items: [
            { key: "admin-hub", labelKey: "admin_menu.item.admin_hub", icon: LayoutDashboard, to: "/admin/overview", hero: true },
            { key: "admin-home", labelKey: "admin_menu.item.admin_home", icon: ShieldCheck, to: "/admin" },
            { key: "admin-users", labelKey: "admin_menu.item.admin_users", icon: Users, to: "/admin/users" },
            { key: "admin-audit-log", labelKey: "admin_menu.item.admin_audit_log", icon: ScrollText, to: "/admin/audit-log" },
            { key: "admin-observability", labelKey: "admin_menu.item.admin_observability", icon: TrendingUp, to: "/admin/observability" },
            { key: "admin-payments", labelKey: "admin_menu.item.admin_payments", icon: CreditCard, to: "/admin/payments" },
            { key: "admin-webhooks", labelKey: "admin_menu.item.admin_webhooks", icon: Webhook, to: "/admin/webhooks" },
            { key: "admin-marketplace-mod", labelKey: "admin_menu.item.admin_marketplace_mod", icon: ShoppingBag, to: "/admin/marketplace/moderation" },
            { key: "admin-blog-engine", labelKey: "admin_menu.item.admin_blog_engine", icon: FileText, to: "/admin/blog-engine/articles" },
            { key: "admin-ai-engine", labelKey: "admin_menu.item.admin_ai_engine", icon: Brain, to: "/admin/ai-engine" },
            { key: "admin-crm-contacts", labelKey: "admin_menu.item.admin_crm_contacts", icon: UsersIcon, to: "/admin/crm/contacts" },
            { key: "admin-outreach", labelKey: "admin_menu.item.admin_outreach", icon: Megaphone, to: "/admin/outreach" },
            { key: "admin-system-settings", labelKey: "admin_menu.item.admin_system_settings", icon: ToggleRight, to: "/admin/system-settings" },
            { key: "admin-feature-flags", labelKey: "admin_menu.item.admin_feature_flags", icon: Flag, to: "/admin/feature-flags" },
        ],
    },
];

// Hotfix Discovery · applica extensions (nuovo gruppo `discovery` dopo `workspace`
// + item `ai-rag` appended a `ai_suite`). Il raw base resta esportato per test.
export const MENU_GROUPS_BASE = _MENU_GROUPS_RAW;
export const MENU_GROUPS = applyMenuDiscoveryExtensions(_MENU_GROUPS_RAW);

// Flat list for keyboard navigation / testing
export const MENU_ITEMS_FLAT = MENU_GROUPS.flatMap((g) => g.items);
